import { useState } from 'react';
import { Error, FillButton, Modal, ModalActions, ModalContent, ModalToolbar, OutlineButton } from '@recargas-dominicanas/core/components';
import type { ICustomer } from '@recargas-dominicanas/core/types';
import { style } from './reset-password-modal.module.css';
import { CustomerApi } from '@recargas-dominicanas/core/api';
import { BusinessStore } from '../../../../store/businessStore';

interface Props {
  open: boolean;
  businessId: number;
  customer: ICustomer;
  onReset: () => void;
  onClose: () => void;
}

export function ResetPasswordModal(props: Props) {

  const {
    open,
    businessId,
    customer,
    onReset,
    onClose
  } = props;

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string>();

  function handleClose() {
    setError(undefined);
    onClose();
  }

  async function handleConfirm() {

    setError(undefined);
    setSaving(true);

    try {
      await CustomerApi.resetPassword(customer.id);
      await BusinessStore.fetchById(businessId);
      onReset();
      onClose();
    } catch {
      setError('No se pudo resetear la contraseña. Inténtalo de nuevo.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal open={open} style={style.modal} onClose={handleClose}>
      <ModalToolbar title='Resetear contraseña' style={style.toolbar} onClose={handleClose}/>
      <ModalContent>
        <div className={style.content}>
          Resetear contraseña del cliente <b>{customer.name} ({customer.username})</b>.
        </div>
        <Error message={error}/>
      </ModalContent>
      <ModalActions>
        <OutlineButton 
          text='Cancelar' 
          disabled={saving} 
          onClick={handleClose}/>
        <FillButton
          text='Aceptar'
          disabled={saving}
          onClick={handleConfirm}/>
      </ModalActions>
    </Modal>
  );
}

